import { useState, useEffect } from 'react';

export const useSales = () => {
  const [sales, setSales] = useState([]);
  const [loading, setLoading] = useState(true);
  const [stats, setStats] = useState({
    totalRevenue: 0,
    totalOrders: 0,
    avgOrderValue: 0,
    conversionRate: 0
  });

  useEffect(() => {
    // Mock data
    const mockSales = [
      { id: '1', total: 1000, status: 'completed' },
      { id: '2', total: 2000, status: 'processing' }
    ];
    
    setSales(mockSales);
    
    const totalRevenue = mockSales.reduce((sum, sale) => sum + sale.total, 0);
    const stats = {
      totalRevenue,
      totalOrders: mockSales.length,
      avgOrderValue: mockSales.length > 0 ? totalRevenue / mockSales.length : 0,
      conversionRate: 15
    };
    
    setStats(stats);
    setLoading(false);
  }, []);

  return { sales, loading, stats };
};